import { render } from "./LottoBuyGame.vue?vue&type=template&id=b3293502&scoped=true&ts=true"
import script from "./LottoBuyGame.vue?vue&type=script&lang=ts"
export * from "./LottoBuyGame.vue?vue&type=script&lang=ts"

import "./LottoBuyGame.vue?vue&type=style&index=0&id=b3293502&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3293502"]])

export default __exports__